// extracted by mini-css-extract-plugin
export default {"header":"Header_header__ji1v2","burger":"Header_burger__+NqnW","burgerSpan":"Header_burgerSpan__AtRnB","active":"Header_active__gI9hN","headerTools":"Header_headerTools__0z6po"};